// src/components/Admin/Finance/forms/AddEditSaleForm.js
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import { SERVICE_TYPES } from "../../../../utils/constants";


export function AddEditSaleForm({
  sale = null,
  clients = [],
  onSubmit,        // (payload) => Promise
  onClose,
  onSuccess,
}) {
  const submitLock = useRef(false);

  const [form, setForm] = useState({
    service_type: "web",
    description: "",
    amount_without_igv: "",
    invoiced: false,
    issue_date: "",
    due_date: "",
  });

const [clientValue, setClientValue] = useState(null);
const [clientInput, setClientInput] = useState("");
  const [loading, setLoading] = useState(false);






  useEffect(() => {
    if (!sale) return;
      setClientValue(sale.client || null);
      setClientInput(sale.client?.name || "");

    setForm({
      service_type: sale.service_type || "web",
      description: sale.description || "",
      amount_without_igv: sale.amount_without_igv ?? "",
      invoiced: Boolean(sale.invoiced),
      issue_date: sale.issue_date || "",
      due_date: sale.due_date || "",
    });

    // si backend devuelve "client" como objeto
    setClientValue(sale.client || null);
  }, [sale]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };



const buildClientPayload = () => {
  // Caso 2: seleccionó existente
  if (clientValue && typeof clientValue === "object" && clientValue.id) {
    return { client_id: clientValue.id };
  }

  // Caso 1: escribió nuevo
  const typed = (clientInput || "").trim();
  if (typed) return { client_create: { name: typed, tax_id: "" } };

  // Caso 3: vacío
  return { client_id: null };
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔒 evita doble submit
    if (submitLock.current) return;
    submitLock.current = true;

    try {
      setLoading(true);

      const clientPayload = buildClientPayload();

      // ✅ whitelist payload (NO incluir payments nunca)
      const payload = {
        ...clientPayload,
        service_type: form.service_type,
        description: form.description,
        amount_without_igv: Number(form.amount_without_igv || 0),
        invoiced: Boolean(form.invoiced),
        issue_date: form.issue_date || null,
        due_date: form.due_date || null,
      };

      await onSubmit(payload);

      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err) {
      console.error("Error guardando venta:", err);
    } finally {
      setLoading(false);
      submitLock.current = false;
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {/* CLIENTE */}
        <Grid item xs={12}>
          <Autocomplete
                freeSolo
                options={clients || []}
                value={clientValue}
                inputValue={clientInput}
                onChange={(e, newValue) => setClientValue(newValue)}
                onInputChange={(e, newInputValue) => setClientInput(newInputValue)}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  return option?.name || "";
                }}
                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                renderInput={(params) => (
                  <TextField {...params} label="Cliente (opcional)" size="small" fullWidth />
                )}
              />

        </Grid>

        {/* SERVICE TYPE */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            name="service_type"
            label="Tipo de servicio"
            value={form.service_type}
            onChange={handleChange}
            size="small"
            fullWidth
          >
            {SERVICE_TYPES.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* MONTO */}
        <Grid item xs={12} sm={6}>
          <TextField
            type="number"
            name="amount_without_igv"
            label="Monto sin IGV"
            value={form.amount_without_igv}
            onChange={handleChange}
            size="small"
            fullWidth
          />
        </Grid>

        {/* DESCRIPCIÓN */}
        <Grid item xs={12}>
          <TextField
            name="description"
            label="Descripción"
            value={form.description}
            onChange={handleChange}
            size="small"
            fullWidth
            multiline
            minRows={2}
          />
        </Grid>

        {/* FACTURADA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={form.invoiced}
                onChange={handleChange}
                name="invoiced"
              />
            }
            label="Venta facturada (aplica IGV)"
          />
        </Grid>

        {/* FECHAS */}
        <Grid item xs={12} sm={6}>
          <TextField
            type="date"
            name="issue_date"
            label="Fecha de emisión"
            value={form.issue_date}
            onChange={handleChange}
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            type="date"
            name="due_date"
            label="Fecha de vencimiento"
            value={form.due_date}
            onChange={handleChange}
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* ACTIONS */}
        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={onClose} variant="outlined">
            Cancelar
          </Button>

          <Button type="submit" variant="contained" disabled={loading}>
            {sale ? "Actualizar venta" : "Crear venta"}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
